// extracted by mini-css-extract-plugin
export default {"prev":"index_prev_DQbnr"};